import { render, staticRenderFns } from "./DealerStatusDetails.vue?vue&type=template&id=00b19ab8&scoped=true"
import script from "./DealerStatusDetails.vue?vue&type=script&lang=js"
export * from "./DealerStatusDetails.vue?vue&type=script&lang=js"
import style0 from "./DealerStatusDetails.vue?vue&type=style&index=0&id=00b19ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b19ab8",
  null
  
)

export default component.exports